export default __webpack_public_path__ + "static/media/ADM.b3f10ec7.svg";